import script from "./ServiceDistributionConfirmModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceDistributionConfirmModal.vue?vue&type=script&setup=true&lang=js"

import "./ServiceDistributionConfirmModal.vue?vue&type=style&index=0&id=750e0dc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-750e0dc0"]])

export default __exports__